module.exports = __webpack_public_path__ + "8274c99f6fb6bf4b41a8f121a96bec05.png";